var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.title)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }